<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"
        v-on:popupopened="SetPopupRef('Dialog')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialog>


    <form autocomplete="off" style="width:100%; box-sizing:border-box;">

      <div style="width:100%; box-sizing:border-box; text-align:left; padding-bottom: 20px;">

            <div class="innerform_cont" v-show="innerform==-2">
                A paraméter adatok már elévültek!
            </div>

            <div class="StepProgress_cont" v-show="innerform>0">
                <GrcStepProgress ref="StepProgress" />
            </div>

            <div class="innerform_cont innerform_smallercont" v-show="innerform==-10">
                <div class="header_login_data" style="margin-bottom: 20px;">Azonosítási adatok</div>

                <GrcDate ref="txtSzuletesiIdo_precheck" v-model="SzuletesiIdo_precheck" grc_dateformat="ymd" grc_sep="." 
                grc_labeltext="Születési idő:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                v-on:grc-keydown-enter="SetControlToFocus('cboNem_precheck');"
                v-on:dropdownopened="SetPopupRef('txtSzuletesiIdo_precheck')"
                v-on:dropdownclosed="SetPopupRef('')"
                style="margin-bottom:10px;"
                />

                <GrcCombo ref="cboNem_precheck" v-model="NemID_precheck" grc_labeltext="Neme:"
                grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                grc_keyfield="id" grc_displayfield="Megnevezes"
                grc_readonly="false"
                v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                v-on:dropdownopened="SetPopupRef('cboNem_precheck')"
                v-on:dropdownclosed="SetPopupRef('')"
                v-on:grc-keydown-enter="SetControlToFocus('cboAllampolgarsag_precheck');"
                style="margin-bottom:10px;"
                />

                <GrcCombo ref="cboAllampolgarsag_precheck" v-model="AllampolgarsagID_precheck" grc_labeltext="Állampolgárság:"
                grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                grc_keyfield="id" grc_displayfield="Megnevezes"
                grc_readonly="false"
                v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                v-on:dropdownopened="SetPopupRef('cboAllampolgarsag_precheck')"
                v-on:dropdownclosed="SetPopupRef('')"
                v-on:grc-keydown-enter="SetControlToFocus('');"
                v-on:innerindexbroadcast="cboAllampolgarsag_precheck_InnerIndexBroadcasted"
                style="margin-bottom:10px;"
                />



                <div class="general_infotext" style="margin:10px 0px; text-align:justify;">
                    Az egészségügyi ellátások során a TAJ száma szükséges, ennek segítségével tudjuk biztonságossá tenni a foglalást.
                </div>

                <table style="width:100%; margin: 10px 0px 10px 0px;" cellspacing="0" cellpadding="0" v-show="CsakTajEnabled==0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkVanTaj" v-on:valuechanged="chkVanTajClicked" /></td>
                    <td valign="top" style="text-align:justify; font-family:'CmsDefault'; font-size:16px; line-height:22px; color:#222;padding-top: 0px;">
                        {{VanTajText}}
                    </td>
                </tr>
                </table>
                <GrcTajszam ref="txtTajSzam_precheck" v-show="IgazolvanyTipus==1"
                grc_labeltext="TAJ szám:"
                grc_placeholder="..."
                grc_labelmode="" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                style="max-width:500px;" 
                />
                <GrcText ref="txtUtlevelSzam_precheck" v-show="IgazolvanyTipus==0"
                grc_labeltext="Útlevél száma:"
                grc_placeholder="..."
                grc_labelmode="" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                style="max-width:500px;" 
                />



                <div class="btncont" style="margin: 30px 0px 0px 0px; text-align:center;">

                    <span @click="btnMegsem_precheck_click" class="painted_linkbutton2 color7" style="margin: 4px 8px;">
                        <span><i class="fal fa-times" style="margin-right: 4px;"></i>Mégsem</span>
                    </span>        

                    <span @click="btnRendben_precheck_click" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                        <span>Tovább<i class="fal fa-chevron-right" style="margin-left: 4px;"></i></span>
                    </span>        

                </div>          


            </div>



            <div class="innerform_cont" v-show="innerform==1">

                <div class="header_login_data" style="margin-bottom:20px;">Személyes adatok</div>

                <div class="htart_table">
                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcText ref="txtVezeteknev"
                            grc_labeltext="Vezetéknév:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            grc_readonly="false"
                            v-on:grc-keydown-enter="SetControlToFocus('txtKeresztnev');"
                            />
                        </div>
                        <div class="htart_col2">
                            <GrcText ref="txtKeresztnev"
                            grc_labeltext="Keresztnév:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            grc_readonly="false"
                            v-on:grc-keydown-enter="SetControlToFocus('cboNem');"
                            />
                        </div>
                    </div>

                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcCombo ref="cboNem" v-model="NemID" grc_labeltext="Neme:"
                            grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                            grc_keyfield="id" grc_displayfield="Megnevezes"
                            grc_readonly="false"
                            v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                            v-on:dropdownopened="SetPopupRef('cboNem')"
                            v-on:dropdownclosed="SetPopupRef('')"
                            v-on:grc-keydown-enter="SetControlToFocus('txtAnyjaNeve');"
                            />
                        </div>
                        <div class="htart_col2">
                            <GrcText ref="txtAnyjaNeve"
                            grc_labeltext="Anyja neve:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            grc_readonly="false"
                            v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiHely');"
                            />
                        </div>
                    </div>


                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcText ref="txtSzuletesiHely"
                            grc_labeltext="Születési hely:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            grc_readonly="false"
                            v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiIdo');"
                            />
                        </div>
                        <div class="htart_col2">
                            <GrcDate ref="txtSzuletesiIdo" v-model="SzuletesiIdo" grc_dateformat="ymd" grc_sep="." 
                            grc_labeltext="Születési idő:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                            v-on:grc-keydown-enter="SetControlToFocus('');"
                            v-on:dropdownopened="SetPopupRef('txtSzuletesiIdo')"
                            v-on:dropdownclosed="SetPopupRef('')"
                            />
                        </div>
                    </div>


                </div>

                <div class="general_infotext">
                    Az egészségügyi ellátások során Önt a TAJ száma azonosítja, ennek segítségével tudjuk biztonságossá tenni a foglalást.
                </div>


                <div class="htart_table">
                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcTajszam ref="txtTajSzam" v-show="IgazolvanyTipus==1"
                            grc_labeltext="TAJ szám:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:grc-keydown-enter="SetControlToFocus('txtA_Irszam');"
                            />
                            <GrcText ref="txtUtlevelSzam" v-show="IgazolvanyTipus==0"
                            grc_labeltext="Útlevél száma:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:grc-keydown-enter="SetControlToFocus('txtA_Irszam');"
                            />

                        </div>
                        <div class="htart_col2 htart_col_empty">
                            &nbsp;
                        </div>
                    </div>
                </div>


                <div class="btncont" style="margin-top:30px;">

                    <span @click="btnStepTo(2)" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                        <span><i class="fal fa-chevron-right" style="margin-right: 4px;"></i>Tovább</span>
                    </span>        

                </div>



            </div>


            <div class="innerform_cont" v-show="innerform==2">
                
                <div class="header_login_data">Számlázási cím megadása</div>

                <div class="general_infotext" style="margin: 10px 0px;">
                    Az egészségügyi ellátást végző szolgáltatók, az Ön nevére és címére állítanak ki számlát. Ezt a  Biztosítónak küldik el és az kifizeti. 
                    Ezért szükséges a számlázási cím megadása.
                </div>


                <div class="htart_table">
                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcIrszam ref="txtA_Irszam"
                            grc_labeltext="Irányítószám:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:valuechanged="Irszam_ValueChanged(1, true)"
                            v-on:grc-keydown-enter="SetControlToFocus('A_Helyseg');"
                            />
                        </div>
                        <div class="htart_col2">
                            <GrcCombo ref="A_Helyseg" v-model="A_Helyseg" grc_labeltext="Helység:"
                            grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                            grc_keyfield="id" grc_displayfield="Megnevezes"
                            v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                            v-on:grc-keydown-enter="SetControlToFocus('txtA_KozterNev');"
                            v-on:valuechanged="A_Helyseg_valuechanged"
                            v-on:dropdownopened="SetPopupRef('A_Helyseg')"
                            v-on:dropdownclosed="SetPopupRef('')"
                            />
                        </div>
                    </div>

                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcText ref="txtA_KozterNev"
                            grc_labeltext="Közterület:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:grc-keydown-enter="SetControlToFocus('A_KozterJelleg');"
                            />
                        </div>
                        <div class="htart_col2">
                            <GrcCombo ref="A_KozterJelleg" v-model="A_KozterJelleg" grc_labeltext="Közterület jelleg:"
                            grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                            grc_keyfield="id" grc_displayfield="Megnevezes"
                            v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                            v-on:grc-keydown-enter="SetControlToFocus('txtA_Hazszam');"
                            v-on:dropdownopened="SetPopupRef('A_KozterJelleg')"
                            v-on:dropdownclosed="SetPopupRef('')"
                            />
                        </div>
                    </div>

                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcText ref="txtA_Hazszam"
                            grc_labeltext="Házszám:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:grc-keydown-enter="SetControlToFocus('txtA_Epulet');"
                            />
                        </div>
                        <div class="htart_col2">
                            <GrcText ref="txtA_Epulet"
                            grc_labeltext="Épület:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:grc-keydown-enter="SetControlToFocus('txtA_Lepcsohaz');"
                            />
                        </div>
                    </div>

                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcText ref="txtA_Lepcsohaz"
                            grc_labeltext="Lépcsőház:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:grc-keydown-enter="SetControlToFocus('txtA_Emelet');"
                            />
                        </div>
                        <div class="htart_col2">
                            <GrcText ref="txtA_Emelet"
                            grc_labeltext="Emelet:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:grc-keydown-enter="SetControlToFocus('txtA_Ajto');"
                            />
                        </div>
                    </div>

                    <div class="htart_tablerow">
                        <div class="htart_col2">
                            <GrcText ref="txtA_Ajto"
                            grc_labeltext="Ajtó:"
                            grc_placeholder="..."
                            grc_labelmode="" grc_labelwidth="200px" 
                            v-on:grc-keydown-enter="SetControlToFocus('');"
                            />
                        </div>
                        <div class="htart_col2">&nbsp;</div>
                    </div>
                </div>

                <div class="btncont" style="margin-top:30px;">

                    <span @click="btnStepTo(1)" class="painted_linkbutton2 color7" style="margin: 4px 8px;">
                        <span><i class="fal fa-chevron-left" style="margin-right: 4px;"></i>Vissza</span>
                    </span>        

                    <span @click="btnStepTo(3)" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                        <span>Tovább<i class="fal fa-chevron-right" style="margin-left: 4px;"></i></span>
                    </span>        

                </div>


            </div>


            <div class="innerform_cont" v-show="innerform==3">

                <div class="header_login_data" style="margin-bottom:30px;">Adatkezelés a Prémium Ellátás oldalon</div>


                <table style="width:100%; margin-bottom:10px;" cellspacing="0" cellpadding="0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkNyilatkozat" /></td>
                    <td valign="top" style="text-align:justify; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222; padding-top:0px;"
                    v-html="chkNyilatkozat">
                    </td>
                </tr>
                </table>


                <div class="btncont" style="margin-top:30px;">


                    <span @click="btnStepTo(2)" class="painted_linkbutton2 color7" style="margin: 4px 8px;">
                        <span><i class="fal fa-chevron-left" style="margin-right: 4px;"></i>Vissza</span>
                    </span>        

                    <span @click="btnRegisztracio_click" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                        <span><i class="fal fa-check" style="margin-right: 4px;"></i>Regisztráció mentése</span>
                    </span>        


                    <span @click="btnMegsem_click" class="painted_linkbutton2 color7" style="margin: 4px 8px;">
                        <span><i class="fal fa-times" style="margin-right: 4px;"></i>Mégsem</span>
                    </span>        


                </div>


            </div>


      </div>
    </form>

    </div>
</template>

<script>


import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcPasswordStrength from '../GrcComponents/GrcPasswordStrength.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcTajszam from '../GrcComponents/GrcTajszam.vue'
import GrcIrszam from '../GrcComponents/GrcIrszam.vue'
import GrcStepProgress from '../GrcComponents/GrcStepProgress.vue'

export default {
  name: 'frmkiskregisztracio',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcPasswordStrength,
      GrcCheckboxMobile,
      GrcDate,
      GrcTajszam,
      GrcIrszam,
      GrcStepProgress,
  },
  props: {
  },
  data () {
      return {
        txtTitle: "",
        innerform: 0,

        NemID:0,
        SzuletesiIdo:"",
        IgazolvanyTipus:1,

        chkNyilatkozat:"",

        VanTajText:"Van TAJ kártyám",


        A_KozterJelleg:0,
        A_Helyseg:0,

        MHDATA:"",

        NemID_precheck:0,
        AllampolgarsagID_precheck:0,
        SzuletesiIdo_precheck:"",
        CsakTajEnabled:0,

        ALLAMPOLGARSAG:[],


      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmKiskRegisztracio", pCompName);
    },

    BiztNyilTeljesSzovegMutat()
    {
        this.biztositoi_nyilatkozat_tag = this.szovegkonyv_bizt_nyil;
        this.BiztNyilTeljesSzovegMutatva = true;
    },


    SetLang()
    {
        this.chkNyilatkozat = this.GetTextBookItem("chkNyilatkozat");

        this.Init();
    },

    HandleCommError(pErrorText)
    {
        this.ShowResult(pErrorText, 200);
    },


    cboAllampolgarsag_precheck_InnerIndexBroadcasted(pIndex)
    {
        var id = this.ALLAMPOLGARSAG[pIndex].id;
        if (id == 1)
        {
            this.CsakTajEnabled = 1;
            this.IgazolvanyTipus = 1;
            this.$refs.chkVanTaj.SetValue(1);
        }
        else
        {
            this.CsakTajEnabled = 0;
        }
    },

    btnRendben_precheck_click()
    {

        var ErrorCompName = "";
        if (this.$refs.txtSzuletesiIdo_precheck.GetText() == '')
        {
            if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiIdo_precheck"; }
            this.$refs.txtSzuletesiIdo_precheck.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }
        else
        {
            if (this.$refs.txtSzuletesiIdo_precheck.IsValid(false) == false)
            {
                if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiIdo_precheck"; }
                this.$refs.txtSzuletesiIdo_precheck.ShowError("A dátum helytelen!");
            }
        }

        if (this.$refs.cboNem_precheck.GetValue() == 0)
        {
            if (ErrorCompName == "") { ErrorCompName = "cboNem_precheck"; }
            this.$refs.cboNem_precheck.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.cboAllampolgarsag_precheck.GetValue() == 0)
        {
            if (ErrorCompName == "") { ErrorCompName = "cboAllampolgarsag_precheck"; }
            this.$refs.cboAllampolgarsag_precheck.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.IgazolvanyTipus == 1)
        {
            if (this.$refs.txtTajSzam_precheck.GetText().trim() == "")
            {
                if (ErrorCompName == "") { ErrorCompName = "txtTajSzam_precheck"; }
                this.$refs.txtTajSzam_precheck.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
            }
            else
            {
                if (this.$refs.txtTajSzam_precheck.GetText().trim().length != 9)
                {
                    if (ErrorCompName == "") { ErrorCompName = "txtTajSzam_precheck"; }
                    this.$refs.txtTajSzam_precheck.ShowError("A TAJ szám hibás!");
                }
            }
        }
        else
        {
            if (this.$refs.txtUtlevelSzam_precheck.GetText().trim() == "")
            {
                if (ErrorCompName == "") { ErrorCompName = "txtUtlevelSzam_precheck"; }
                this.$refs.txtUtlevelSzam_precheck.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
            }
            else
            {
                if (this.$refs.txtUtlevelSzam_precheck.GetText().trim().length < 5)
                {
                    if (ErrorCompName == "") { ErrorCompName = "txtUtlevelSzam_precheck"; }
                    this.$refs.txtUtlevelSzam_precheck.ShowError("Az útlevélszám hibás!");
                }
            }
        }


        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }

        this.RegCheck();
    },

    async RegCheck()
    {
        var ISZ = "";
        if (this.IgazolvanyTipus == 1)
        {
            ISZ = this.$refs.txtTajSzam_precheck.GetText().trim();
        }
        else
        {
            ISZ = this.$refs.txtUtlevelSzam_precheck.GetText().trim();
        }


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sSzulDatum: this.$refs.txtSzuletesiIdo_precheck.GetText(),
            iNemID: this.$refs.cboNem_precheck.GetValue(),
            iAllampolgarsagID: this.$refs.cboAllampolgarsag_precheck.GetValue(),
            sIgazolvanySzam: ISZ,
            iIsTaj:this.IgazolvanyTipus,
            sMHDATA: this.MHDATA,

        };


        var Q;
        await this.$refs.GRCDB.GetData("frmKiskRegisztracio_RegCheck", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowResult(Q.APPERR[0].ERR, 200);
            return;
        }

        //console.log(Q.RESULT);

        this.$refs.txtSzuletesiIdo.SetText(this.$refs.txtSzuletesiIdo_precheck.GetText());
        this.$refs.cboNem.SetValue(this.$refs.cboNem_precheck.GetValue());
        if (this.IgazolvanyTipus == 1)
        {
            this.$refs.txtTajSzam.SetText(this.$refs.txtTajSzam_precheck.GetText());
            this.$refs.txtUtlevelSzam.SetText("");
        }
        else
        {
            this.$refs.txtUtlevelSzam.SetText(this.$refs.txtUtlevelSzam_precheck.GetText());
            this.$refs.txtTajSzam.SetText("");
        }

        this.$refs.GRCDB.HideLoading();


        let loaddata = true;
        if (Q.HTARTDATA.hasOwnProperty("intResult")) { loaddata = false;}

        if ((loaddata)&&(Q.HTARTDATA.length == 0)) { loaddata = false; }

        if (loaddata == false)
        {
            this.ShowResult("A regisztrációs azonosítóhoz tartozó adatok és a megadott nem és születési idő nem egyezik!", 200);
            return;
        }


        if (loaddata)
        {
            this.$refs.txtA_Irszam.SetText(Q.HTARTDATA[0].Irszam);
            //this.$refs.A_Helyseg.SetValue(Q.HTARTDATA[0].HelysegID);
            this.$refs.txtA_KozterNev.SetText(Q.HTARTDATA[0].KozterNev);
            this.$refs.A_KozterJelleg.SetValue(Q.HTARTDATA[0].KozterJellegID);
            this.$refs.txtA_Hazszam.SetText(Q.HTARTDATA[0].Hazszam);
            this.$refs.txtA_Epulet.SetText(Q.HTARTDATA[0].Epulet);
            this.$refs.txtA_Lepcsohaz.SetText(Q.HTARTDATA[0].Lepcsohaz);
            this.$refs.txtA_Emelet.SetText(Q.HTARTDATA[0].Emelet);
            this.$refs.txtA_Ajto.SetText(Q.HTARTDATA[0].Ajto);
            
            this.$refs.txtVezeteknev.SetText(Q.HTARTDATA[0].Vezeteknev);
            this.$refs.txtKeresztnev.SetText(Q.HTARTDATA[0].Keresztnev);
            this.$refs.txtAnyjaNeve.SetText(Q.HTARTDATA[0].AnyjaNeve);
            this.$refs.txtSzuletesiHely.SetText(Q.HTARTDATA[0].SzulHely);

            await this.Irszam_ValueChanged(1, false)
        }        





        this.$refs.StepProgress.SetValue(1);
        this.innerform = 1;
        

    },


    btnMegsem_precheck_click()
    {
        document.location = "dashboard";
        return;
    },



    HideErrors()
    {
        //this.$refs.ErrorBox.HideError();


        this.$refs.txtVezeteknev.HideError();
        this.$refs.txtKeresztnev.HideError();
        this.$refs.cboNem.HideError();
        this.$refs.txtAnyjaNeve.HideError();
        this.$refs.txtSzuletesiHely.HideError();
        this.$refs.txtSzuletesiIdo.HideError();


        this.$refs.txtTajSzam.HideError();
        this.$refs.txtUtlevelSzam.HideError();

        this.$refs.txtA_Irszam.HideError();
        this.$refs.A_Helyseg.HideError();
        this.$refs.txtA_KozterNev.HideError();
        this.$refs.A_KozterJelleg.HideError();
        this.$refs.txtA_Hazszam.HideError();

    },


    A_Helyseg_valuechanged()
    {
        this.$refs.A_Helyseg.HideError();
    },

    async Irszam_ValueChanged(pControlID, pSetFocus)
    {
        // pControlID: 1 - Allando irszam, 2 - Level irszam
        var pIrszam = "";
        if (pControlID == 1) { pIrszam = this.$refs.txtA_Irszam.GetText(); }
        //if (pControlID == 2) { pIrszam = this.$refs.txtL_Irszam.GetText(); }

        //console.log("irszam changed: "+pIrszam);

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sSessionID: "[APPSESSIONID]",
            sIrszam: pIrszam,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmKiskRegisztracio_GetHelysegek", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            //this.ShowResult(Q.APPERR[0].ERR, 200);
            //alert(Q.APPERR[0].ERR);
            return;
        }

        if (pControlID == 1)
        {
            this.$refs.A_Helyseg.SetDataSource(Q.RESULT);
            if (Q.RESULT.length>1)
            {
                //console.log("id to: "+Q.RESULT[1].id);
                this.$refs.A_Helyseg.SetValue(Q.RESULT[1].id);
            }
            else
            {
                this.$refs.A_Helyseg.SetValue(0);
            }

            if (pSetFocus)
            {
                this.SetControlToFocus("A_Helyseg");
            }
        }

        /*
        if (pControlID == 2)
        {
            this.$refs.L_Helyseg.SetDataSource(Q.RESULT);
            if (Q.RESULT.length>1)
            {
                this.$refs.L_Helyseg.SetValue(Q.RESULT[1].id);
            }
            else
            {
                this.$refs.L_Helyseg.SetValue(0);
            }
            this.SetControlToFocus("L_Helyseg");
        }
        */
        this.$refs.GRCDB.HideLoading();
    },





    btnRegisztracio_click()
    {
        this.HideErrors();

        if (this.$refs.chkNyilatkozat.GetValue() == 0)
        {
            this.ShowResult("A nyilatkozatok és hozzájárulások elfogadása kötelező!", 200);
            return;
        }


        var ErrorCompName = "";


        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }



      this.SaveReg();
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        if (pNextComp == "TajOrUtlevel")
        {
            if (this.$refs.chkVanTaj.GetValue() == 1) { pNextComp = "txtTajSzam"; }
            else { pNextComp = "txtUtlevelSzam"; }
        }

        this.$refs[pNextComp].SetFocus();
    },

    btnMegsem_click()
    {
        document.location = "dashboard";
    },



    chkVanTajClicked()
    {
        this.$refs.txtTajSzam.HideError();
        this.$refs.txtUtlevelSzam.HideError();

        this.IgazolvanyTipus = this.$refs.chkVanTaj.GetValue();

        if (this.IgazolvanyTipus == 1) 
        {
            this.VanTajText = "Van TAJ kártyám";
        }
        else
        {
            this.VanTajText = "Külföldi állampolgár vagyok, nincs TAJ kártyám";
        }
    },


    async SaveReg()
    {

      this.$refs.GRCDB.ShowLoading(false);

      var QP = {
          sSessionID: "[APPSESSIONID]",

          sVezeteknev: this.$refs.txtVezeteknev.GetText(),
          sKeresztnev: this.$refs.txtKeresztnev.GetText(),
          iNemID: this.$refs.cboNem.GetValue(),
          sAnyjaNeve: this.$refs.txtAnyjaNeve.GetText(),
          sSzuletesiHely: this.$refs.txtSzuletesiHely.GetText(),
          sSzuletesiIdo: this.$refs.txtSzuletesiIdo.GetText(),

          iVanTaj: this.IgazolvanyTipus,
          sTajSzam: this.$refs.txtTajSzam.GetText(),
          sUtlevelszam: this.$refs.txtUtlevelSzam.GetText(),
          iMarketing: 0,

            sA_Irszam: this.$refs.txtA_Irszam.GetText(),
            iA_HelysegID: this.$refs.A_Helyseg.GetValue(),
            sA_KozterNev: this.$refs.txtA_KozterNev.GetText(),
            iA_KozterJellegID: this.$refs.A_KozterJelleg.GetValue(),
            sA_Hazszam: this.$refs.txtA_Hazszam.GetText(),
            sA_Epulet: this.$refs.txtA_Epulet.GetText(),
            sA_Lepcsohaz: this.$refs.txtA_Lepcsohaz.GetText(),
            sA_Emelet: this.$refs.txtA_Emelet.GetText(),
            sA_Ajto: this.$refs.txtA_Ajto.GetText(),

            sMHDATA: this.MHDATA

          
      };
      var Q;

      await this.$refs.GRCDB.GetData("frmKiskRegisztracio_Save", QP).then(res => { Q = res; });

      if (Q.APPERR[0].ERR != "")
      {
          this.$refs.GRCDB.HideLoading();
          this.ShowResult(Q.APPERR[0].ERR, 200);
          return;
      }

      this.$refs.GRCDB.HideLoading();

        await this.ShowResult(Q.RESULT[0].InfoText, 200);

        if (Q.RESULT[0].intResult == 1)
        {
            document.location = "https://portal.premiumegeszsegpenztar.hu/main/premiumellatas";
        }

    },



    async Init()
    {
        this.$refs.StepProgress.Init([ {text:"Személyes adatok"}, {text:"Számlázási cím megadása"}, {text:"Regisztráció létrehozása"} ]);        

        this.scrollToTop();

        this.HideErrors();

        GRCAPP_GetParameters.ALIAS = GRCAPP_GetParameters.ALIAS.toLowerCase();

        this.MHDATA = "";
        if ((GRCAPP_GetParameters.MHDATA != "") && (GRCAPP_GetParameters.MHDATA != undefined))
        {
            this.MHDATA = GRCAPP_GetParameters.MHDATA;
            GRCAPP_GetParameters.MHDATA = "";
        }


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sSessionID: "[APPSESSIONID]",
            sMHDATA: this.MHDATA
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmKiskRegisztracio_Init", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowResult(Q.APPERR[0].ERR, 200);
            //alert(Q.APPERR[0].ERR);
            return;
        }

        if (Q.MH[0].MeghivoErvenyes == 0)
        {
            this.$refs.GRCDB.HideLoading();
            this.innerform = -2;
            return;
        }

        this.ALLAMPOLGARSAG = Q.ALLAMPOLGARSAG;


        this.$refs.cboNem.SetDataSource(Q.NEM);
        this.$refs.cboNem.SetValue(0);

        this.$refs.cboNem_precheck.SetDataSource(Q.NEM);
        this.$refs.cboNem_precheck.SetValue(0);

        this.$refs.cboAllampolgarsag_precheck.SetDataSource(Q.ALLAMPOLGARSAG);
        this.$refs.cboAllampolgarsag_precheck.SetValue(0);


        this.$refs.A_Helyseg.SetDataSource(Q.ALLHELYSEG);
        this.$refs.A_Helyseg.SetValue(0);
        this.$refs.A_KozterJelleg.SetDataSource(Q.KOZTERJELLEG);
        this.$refs.A_KozterJelleg.SetValue(0);

        this.$refs.chkVanTaj.SetValue(1);
        this.IgazolvanyTipus = 1;
        this.CsakTajEnabled = 0;

        this.$refs.chkVanTaj.SetValue(1);


        

        this.innerform = -10;

        this.$refs.GRCDB.HideLoading();
    },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
            //this.Init();
        });               
    },

      btnStepTo(pStepIndex)
      {
          this.HideErrors();

          //pStepIndex = 4;


          if ((this.innerform == 1)&&(pStepIndex==2))
          {
              if (this.CheckStep1() == false) { return; }
          }

          if ((this.innerform == 2)&&(pStepIndex==3))
          {
              if (this.CheckStep2() == false) { return; }
          }

        this.innerform = pStepIndex;
        this.scrollToTop();


        this.$refs.StepProgress.SetValue(pStepIndex);

      },

      CheckStep1()
      {
          var res = true;
          var ErrorCompName = "";

        if (this.$refs.txtVezeteknev.GetText() == '')
        {
            if (ErrorCompName == "") { ErrorCompName = "txtVezeteknev"; }
            this.$refs.txtVezeteknev.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }


        if (this.$refs.txtKeresztnev.GetText() == '')
        {
            if (ErrorCompName == "") { ErrorCompName = "txtKeresztnev"; }
            this.$refs.txtKeresztnev.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.cboNem.GetValue() == 0)
        {
            if (ErrorCompName == "") { ErrorCompName = "cboNem"; }
            this.$refs.cboNem.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtAnyjaNeve.GetText() == '')
        {
            if (ErrorCompName == "") { ErrorCompName = "txtAnyjaNeve"; }
            this.$refs.txtAnyjaNeve.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtSzuletesiHely.GetText() == '')
        {
            if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiHely"; }
            this.$refs.txtSzuletesiHely.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtSzuletesiIdo.GetText() == '')
        {
            if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiIdo"; }
            this.$refs.txtSzuletesiIdo.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }



        //if (this.$refs.chkVanTaj.GetValue() == 1)
        if (this.IgazolvanyTipus == 1)
        {
            if (this.$refs.txtTajSzam.GetText().length != 9)
            {
                if (ErrorCompName == "") { ErrorCompName = "txtTajSzam"; }
                if (this.$refs.txtTajSzam.GetText() == "")
                {
                    this.$refs.txtTajSzam.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
                }
                else
                {
                    this.$refs.txtTajSzam.ShowError("A TAJ szám formátuma nem megfelelő!");
                }
            }
        }
        else
        {
            if (this.$refs.txtUtlevelSzam.GetText() == "")
            {
                if (ErrorCompName == "") { ErrorCompName = "txtTajSzam"; }
                this.$refs.txtUtlevelSzam.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
            }
        }

        if (ErrorCompName != "")
        {
            this.SetControlToFocus(ErrorCompName);
            res = false;
        }

        return res;

      },

      CheckStep2()
      {
          var res = true;
          var ErrorCompName = "";

        if (this.$refs.txtA_Irszam.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtA_Irszam"; }
          this.$refs.txtA_Irszam.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.A_Helyseg.GetValue() == 0)
        {
          if (ErrorCompName == "") { ErrorCompName = "A_Helyseg"; }
          this.$refs.A_Helyseg.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtA_KozterNev.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtA_KozterNev"; }
          this.$refs.txtA_KozterNev.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.A_KozterJelleg.GetValue() == 0)
        {
          if (ErrorCompName == "") { ErrorCompName = "A_KozterJelleg"; }
          this.$refs.A_KozterJelleg.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtA_Hazszam.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtA_Hazszam"; }
          this.$refs.txtA_Hazszam.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (ErrorCompName != "")
        {
            this.SetControlToFocus(ErrorCompName);
            res = false;
        }

        return res;

      },




  },
  created()
  {
    
  },
  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    this.SetLang();

  }

}


</script>


<style scoped>

.tajekoztato
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    text-align: justify;
    margin-bottom: 20px;
}

.innerform_cont
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px 10px;
}

.innerform_header
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: 500;
    text-align: left;
    padding:20px 0px;
}


.htart_table
{
    width: 100%;
    box-sizing: border-box;
    display: table;    
}

.htart_tablerow
{
    display: table-row;    
}

.htart_col2
{
    width: 50%;
    box-sizing: border-box;
    padding: 10px 5px;
    display: table-cell;    
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}


.htart_col_empty
{
    box-sizing: border-box;
}

.header_login_data
{
    width: 100%;
    box-sizing: border-box;
    padding:10px 0px;
    background-color: var(--themecolor3);
    color: #fff;
    text-align: center;    
    margin-top: 20px;

    font-size: 15px;
    line-height: 15px;
    padding-top: 12px;    
    border-radius: 3px;
}

.general_infotext
{
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 22px;
    padding:0px 6px;
}

.innerform_smallercont
{
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    padding: 8px;
}

.btnShowAllText
{
    box-sizing: border-box;
    background-color: var(--themecolor3);
    color:#fff;
    cursor: pointer;
    font-family: 'CmsDefault';
    font-size: 12px;
    line-height: 12px;
    padding:6px;
    border-radius: 2px;
    text-align: center;
    display: inline-block;    
}

.btnShowAllText:hover
{
    opacity:0.8;
}


@media (max-width:800px)
{

    .htart_tablerow
    {
        display: block;
        box-sizing: border-box;
    }

    .htart_col2
    {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 5px;
        display: block;   
    }

    .header_login_data
    {
        margin-top: 20px;
    }

    .htart_col_empty
    {
        display:none;
    }

    .innerform_cont
    {
        padding:0px;
    }

    .innerform_smallercont
    {
        padding: 0px;
    }


}
</style>